module.exports = __webpack_public_path__ + "/login_ui/img/vu-2e560acd9f07d4c041c69daf0f074d1c.svg";